/* eslint-disable ember/no-computed-properties-in-native-classes */
import EnrolResult from './enrol-result';
import { alias } from '@ember/object/computed';

export default class ArrivalResult extends EnrolResult {
  @alias('arrival')
  response;
}
